<app-modal #feedbackModal>
    @if(!feedbackResult){
        <div class="flex flex-row items-center w-full h-full">
            <div class="flex flex-col items-center w-full text-center mx-16">
                <h3 class="pt-6 pb-4">Welches Problem möchtest du melden?</h3>
                    <textarea #feedbackModalTextArea class="rounded w-full h-36 resize-none" type="text" required placeholder="Gebe hier einen Kommentar ein, damit wir wissen, welches Problem auftritt." (input)="handleFeedbackInput()"></textarea>
                    
                    <div class="flex flex-row justify-between gap-4 mt-6">
                        <button class="white-button" (click)="toggleFeedbackModal()">
                            Abbrechen
                        </button>
                        @if(feedbackText.length > 0){
                            <button class="blue-button" (click)="submitFeedback()">
                                Senden
                            </button>
                        } @else {
                            <button class="disabled-button cursor-not-allowed">
                                Senden
                            </button>
                        }
                    </div>
                
            </div>
        </div>
    } @else {
        <div class="flex flex-row items-center w-full h-full">
            <div class="flex flex-col items-center w-full text-center mx-16">
                @if(feedbackResult === 'success'){
                    <h3 class="pt-6 pb-4">Vielen Dank für dein Feedback!</h3>
                } @else {
                    <h3 class="pt-6 pb-4">Hoppla, da ist etwas schief gelaufen. 😢</h3>
                }
                <button class="blue-button" (click)="toggleFeedbackModal()">
                    Schließen
                </button>
            </div>
        </div>
    }
</app-modal>